import loadable from 'Components/AsyncModuleLoader/AsyncModuleLoader';
import loading from '../asyncLoading/asyncLoading';

export default loadable({
    loader: () => import(/* webpackChunkName: "profileCompletion" */'./ProfileCompletion'),
    loading: loading({
        tracking: {
            error: {
                event: 'profileCompletion_errors',
                attrs: {
                    error_origin: 'component_load_failed'
                }
            }
        }
    })
});
